import { Button, Grid, TextField } from "@mui/material";
import { IItem, IProps } from "../../types/CommonTypes";
import Title from "../generic/Title";
import { fieldLabel } from "./sections";
import Item from "./generic/ImageItem";
import { useEffect, useState } from "react";
import useFirebase from "../../commons/firebase/useFirebase";
import { getRandomId } from "../../commons/constants/helpers";

// Sección "La Milagrosa" (website.contact): solo episodios e imagen de fondo.
// Los textos title1/title2/subtitle quedaron sin uso al quitar el formulario
// de voluntarios; el copy de la sección vive en social/Podcast.tsx.
export default function DashboardContact({ item, onChange }: IProps) {
	const [data, setData] = useState<IItem>(item);
	const { uploadFileToStorage } = useFirebase();

	useEffect(() => {
		onChange && onChange(data);
	}, [data]);

	const handleNewPic = async (id: string, file: any) => {
		try {
			let path = "/assets/contact/";
			const downloadURL = await uploadFileToStorage(
				file,
				path + file.name
			);
			let updated: any = data.images.map((item) => {
				if (item.id === id) {
					return {
						id: id,
						name: getRandomId(),
						path: path,
						url: downloadURL,
					};
				}
				return item;
			});

			setData({ ...data, images: updated });
		} catch (error) {
			console.log("Error al cargar el archivo:", error);
		}
	};

	const handleAddNew = () => {
		setData({
			...data,
			videos: [
				...(data.videos || []),
				{
					// con `length` bastaba borrar uno del medio para que el
					// siguiente naciera con un id repetido
					id: getRandomId(),
					url: "",
					title: "",
				},
			],
		});
	};

	// Por posición, no por id: dos episodios con el mismo id se pisaban al
	// editarlos y React renderizaba tarjetas cruzadas.
	const handleText = (index: number, value: string, field: string) => {
		let updated: any = data.videos?.map((video, i) =>
			i === index ? { ...video, [field]: value } : video
		);

		setData({ ...data, videos: updated });
	};

	const deleteVideo = (index: number) => {
		let filtered = data.videos?.filter((item, i) => i !== index);
		setData({ ...data, videos: filtered });
	};
	return (
		<Grid container>
			<Title>Episodios</Title>
			{data.videos?.map((video, index) => (
				<Grid item md={5} key={index} style={{ margin: "20px" }}>
					<Title>{`Episodio ${index + 1}`}</Title>
					<TextField
						fullWidth
						value={video.url}
						label={"Enlace de YouTube"}
						onChange={(e) =>
							handleText(index, e.target.value, "url")
						}
						style={{ marginBottom: "10px" }}
					/>
					<TextField
						fullWidth
						value={video.title}
						label={"Título del episodio"}
						onChange={(e) =>
							handleText(index, e.target.value, "title")
						}
					/>
					<Button
						onClick={() => deleteVideo(index)}
						fullWidth
						variant="contained"
						color="secondary"
						style={{ marginTop: 10 }}
					>
						Eliminar
					</Button>
				</Grid>
			))}
			<Button
				style={{ marginTop: "50px" }}
				onClick={handleAddNew}
				fullWidth
				variant="contained"
			>
				Agregar otro episodio
			</Button>
			<Title>Imágenes</Title>
			{data.images.map((image) => (
				<Item
					key={image.id}
					label={fieldLabel("contact", image.id)}
					source={image.url}
					onUpdate={(file: any) => handleNewPic(image.id, file)}
				/>
			))}
		</Grid>
	);
}
